import { Component, Input } from '@angular/core';
import { LogoComponent } from '@shared/components/page-header/logo/logo.component';

@Component({
  selector: 'od-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss'],
  imports: [LogoComponent],
})
export class PageHeaderComponent {
  @Input() pageTitle: string;
}
